var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.668,
    height: 23.68,
    viewBox: "0 0 30.668 23.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ikon_Kommentar",
    transform: "translate(0.152 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39324",
    "data-name": "Path 39324",
    d: "M8.265,27.009a.406.406,0,0,1-.18,0,.473.473,0,0,1-.293-.435V20.817A8.6,8.6,0,0,1,8.6,3.64H21.642a8.607,8.607,0,0,1-.009,17.215H14.665L8.6,26.867A.444.444,0,0,1,8.265,27.009ZM8.6,4.585A7.659,7.659,0,1,0,8.284,19.9a.473.473,0,0,1,.454.473V25.4l5.436-5.351a.444.444,0,0,1,.331-.142h7.137a7.667,7.667,0,1,0,0-15.324Z",
    transform: "translate(0.122 -3.639)",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39325",
    "data-name": "Path 39325",
    d: "M8.294,15.567a2.534,2.534,0,1,1,2.534-2.534A2.534,2.534,0,0,1,8.294,15.567Zm0-4.122a1.588,1.588,0,1,0,1.588,1.588A1.588,1.588,0,0,0,8.294,11.445Z",
    transform: "translate(-0.2 -4.014)",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39326",
    "data-name": "Path 39326",
    d: "M15.9,15.567a2.534,2.534,0,1,1,2.534-2.534A2.534,2.534,0,0,1,15.9,15.567Zm0-4.122a1.588,1.588,0,1,0,1.588,1.588A1.588,1.588,0,0,0,15.9,11.445Z",
    transform: "translate(-0.616 -4.014)",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39327",
    "data-name": "Path 39327",
    d: "M23.5,15.567a2.534,2.534,0,1,1,2.543-2.534A2.534,2.534,0,0,1,23.5,15.567Zm0-4.122a1.588,1.588,0,1,0,1.129.462A1.588,1.588,0,0,0,23.5,11.445Z",
    transform: "translate(-1.032 -4.014)",
    stroke: "#000",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/Icon_question.b6d02e8ca5faaa3680f5e2fef4351ea3.svg";
export { ForwardRef as ReactComponent };